import Licensee from '@/model/licensee.mjs';
import { Box } from '@chakra-ui/react';
import { BiBadgeCheck } from 'react-icons/bi';
import { useFFLDetailClient } from '@/api/backoffice-api';
import AppConfig from '@/utils/app-config.mjs';
import { useDispatch } from 'react-redux';
import LicenseDetails from './license-details';

interface Props {
  data: Licensee;
  cognitoGroup: boolean;
  isSuperAdmin: boolean;
}

export default function FFLDetail({ data, cognitoGroup, isSuperAdmin }: Props) {
  const dispatch = useDispatch();
  const [{ loading, error, data: dealerData }] = useFFLDetailClient({
    baseURL: AppConfig.fflGetApiBaseURL,
    url: `/license/${data.id.substring(0, 1)}${data.id.substring(
      2,
      4
    )}/${data.id.substring(data.id.length - 5)}`
  });

  function renderData(data: Licensee) {
    return (
      <>
        {data &&
          <div className="license_details__wrapper">
            <LicenseDetails data={data} isSuperAdmin={isSuperAdmin} />
          </div>
        }
      </>
    );
  }

  function renderResult() {
    if (error) {
      const errorMessage =
        error?.response?.status === 404
          ? `No licensee found matching license number ${data.id.substring(
            0,
            1
          )}-${data.id.substring(2, 4)}-xxx-xx-xx-${data.id.substring(
            data.id.length - 5
          )}`
          : `We're sorry. An unexpected error occurred. Please try again, or contact support.`;
      return <Box>{errorMessage}</Box>;
    }
    if (loading) {
      return renderData(data);
    }
    return renderData(dealerData[0]);
  }

  return renderResult();
}

function Verified() {
  return (
    <Box display={'inline'} marginLeft={'.5rem'}>
      <BiBadgeCheck color={'green'} className={'icon'} />
    </Box>
  );
}
